import React from 'react'
import { Trans } from 'react-i18next'
import { useSelector } from 'store/redux.store'

import HotmartLogoWhite from '../../assets/hotmart-logo-white.svg'

import './attendant-header-logo.styles.scss'

const AttendantHeaderLogo = () => {
  const {
    name: userName,
    profile: { tradeName: ownerName }
  } = useSelector(state => state.user)

  const validateName = () => (ownerName && ownerName !== '' ? ownerName : userName)

  return (
    <>
      <a href="/" className="logo-link logo-custom" slot="logo-link">
        <img src={HotmartLogoWhite} alt="Hotmart Logo" />
      </a>
      <span slot="brand-name">
        <span className="attendant-heading _position-relative _text-2 _text-gray-200">
          <Trans i18nKey="header.menu.attendant.user_area" values={{ userName: validateName() }} />
        </span>
      </span>
    </>
  )
}

export default AttendantHeaderLogo
